import React, {memo, useState, useEffect} from 'react';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import PopNavbar from '@/components/Ui-components/PopNavbar';
import Container from '@/components/atoms/Container';
// Server-rendered alongside the footer: the office NAP details must be in the
// raw HTML for local SEO, and reserving its space avoids a late layout shift.
import OfficeAddress from '@/components/Ui-components/Address';
import Footer from '@/components/Ui-components/Common/footer';
const LatestFooter = dynamic(() => import('@/components/Ui-components/latest-footer'), {ssr: false, loading: () => null});
import AppBar from '@/components/Ui-components/Common/app-bar';
import Breadcrumbs from '@/components/Common/Breadcrumbs';
// MUI-free rebuild of the project brief; live on the homepage only for now, other pages keep the MUI version.
const ProjectBriefSection = dynamic(() => import('@/components/organisms/cta/ProjectBrief'), {loading: () => null});
// Loaded on demand: it only mounts after the first scroll/tap, so its MUI code stays out of the shared bundle.
const ProjectBrief = dynamic(() => import('./ProjectBrief'), {loading: () => null});

const MainLayout = (props: any) => {
    const {children} = props;
    const {pathname} = useRouter();

    const [mountForms, setMountForms] = useState<boolean>(false);

    useEffect(() => {
        if (mountForms) return undefined;
        const onIntent = () => setMountForms(true);
        globalThis.addEventListener('scroll', onIntent, {once: true});
        globalThis.addEventListener('pointerdown', onIntent, {once: true});
        return () => {
            globalThis.removeEventListener('scroll', onIntent);
            globalThis.removeEventListener('pointerdown', onIntent);
        };
    }, [mountForms]);

    return (
        <>
            <div>
                <div className="app-bar-main">
                    <Container>
                        <AppBar />
                    </Container>
                </div>
            </div>
            <div className="layout-pop-nav-wrapper">
                <div>
                    <Container>
                        <PopNavbar />
                    </Container>
                </div>
            </div>
            <main id="main-content" role="main">
                <Breadcrumbs />
                {children}
            </main>{' '}
            {mountForms && (pathname === '/' ? <ProjectBriefSection /> : <ProjectBrief />)}
            <div className="address-main">
                <OfficeAddress />
            </div>
            <LatestFooter />
            <Footer />
        </>
    );
};

export default memo(MainLayout);
